<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    fullscreen
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins min-h-100">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">History</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column scroll-y mx-5 py-7"
        v-if="total"
      >
        <v-data-table
          disable-sort
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading"
          class="elevation-0 oms_history"
          :footer-props="{ 'items-per-page-options': item_per_page_list }"
        >
          <template
            v-for="(head, i) in headers"
            v-slot:[`item.`+head.value]="{ item, header, value }"
          >
            <ComponentSelector
              v-bind:key="i"
              :item="item"
              :header="header"
              :value="value"
            />
          </template>

          <template #item.changes_data="{ item, value }">
            <HistoryRow
              :isDataAvailable="value?.before?.rule?.condition"
              :history="parseJSON(value)"
              :userId="client_id"
              :serverData="serverData"
            />
          </template>
        </v-data-table>
        <!--begin::Actions-->
        <!--        <div class="my-4 h-75px d-flex flex-grow-1 align-end justify-center">-->
        <!--          <button-->
        <!--            type="submit"-->
        <!--            class="btn btn-info px-5 py-3 ls1"-->
        <!--            @click="submitForm"-->
        <!--          >-->
        <!--            Submit-->
        <!--          </button>-->
        <!--        </div>-->
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
// import swalEdited from "@/core/services/AlertServices/SwalEdited";
// import swalAdded from "@/core/services/AlertServices/SwalAdded";
import ApiService from "@/core/services/api.service";
// import RuleBuilder from "@/own/components/orderManagement/rules/ruleBuilder/RuleBuilder";
// import ActionBuilder from "@/own/components/orderManagement/rules/actionBuilder/ActionBuilder";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ComponentSelector from "@/own/components/datatable/ComponentSelector.vue";
import HistoryRow from "@/own/components/orderManagement/rules/HistoryRow.vue";

export default {
  name: "OMSRuleHistory",
  props: ["refresher"],
  components: { HistoryRow, ComponentSelector },
  data: () => ({
    dialog: false,
    serverData: null,
    client_id: null,
    headers: null,
    total: 0,
    options: {},
    loading: true,
    items: [],
    item_per_page_list: [20, 30, 40, 50],
    // formData: {
    //   clients: [],
    // },
    rules: [],
  }),
  methods: {
    pageLoader(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },
    toggleModal() {
      if (this.dialog) {
        this.resetFormData();
        this.serverData = null;
        this.dialog = !this.dialog;
      } else {
        this.getDataFromApi();
      }
    },
    resetFormData() {
      this.rules = [];
      this.serverData = null;
    },
    parseJSON(value) {
      return {
        before: {
          attributes: [value.before.attributes],
          query: JSON.parse(value.before.rule.condition),
        },
        after: {
          attributes: [value.after.attributes],
          query: JSON.parse(value.after.rule.condition),
        },
      };
    },
    getDataFromApi() {
      this.pageLoader(true);
      this.loading = true;

      ApiService.post(
        "/order_management/order_management_rules/oms_rule_history",
        { id: this.$store.getters.getItemForAction.id }
      )
        .then(({ data }) => {
          this.serverData = data.data;

          if (data?.data?.body?.data?.length) {
            this.headers = data.data.header;
            this.items = data.data.body.data;
            this.total = data.data.body.total;

            if (data?.data?.body?.data?.changes_data) {
              this.client_id =
                data.data.body.data.changes_data?.before?.clients[0];
            }
            this.dialog = !this.dialog;
            // console.log("this.rules", this.rules);
          } else {
            Swal.fire({
              title: "Warning",
              text: "Historical data is not available for this rule",
              icon: "warning",
            });
          }

          // this.dialog = false;
        })
        // .catch(() => {
        //   this.dialog = false;
        // })
        .finally(() => {
          this.loading = false;
          this.pageLoader(false);
        });
    },
  },
  computed: {
    userId: function () {
      return this.$store.getters.isClient
        ? this.$store.getters.currentUser.data.id
        : this.client_id;
    },
    operands: function () {
      return this.serverData.operands;
    },
    operators: function () {
      return this.serverData.operators;
    },
    isDataLoaded() {
      return !!this.serverData;
    },
  },
};
</script>
